// @flow
import { createReducer } from 'redux-act';
import { arrayToObjectById } from '../../../helpers/league';
import * as actions from '../../actions/positions';
import type { TPositionsReducer } from '../../types';

export const initial_state: TPositionsReducer = {
	by_id: {},
	ordered_ids: [],
};

export const positions = createReducer({}, initial_state);

positions.on(actions.setPositions, (state, payload: any) => ({
	...state,
	ordered_ids: payload.map(item => item.id),
	by_id: arrayToObjectById(payload, state.by_id),
}));

export default positions;


// WEBPACK FOOTER //
// ./src/modules/reducers/positions/index.js